import React, { Fragment, useState, useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { motion } from 'framer-motion'
import { FacebookProvider, Share } from 'react-facebook';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Background from './components/Background';
import Logo from '../../components/Logo/Logo';
import phone from '../../assets/images/home_phone.png';

const Final = ({ minimum, correctAnswers, history, questionsCount, intl: { formatMessage }, finished }) => {
    const [showText, setText] = useState(false);
    const location = window.location.origin + process.env.PUBLIC_URL;
    useEffect(() => {
        if (!finished) {
            history.push('/');
            return;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    })
    const startOver = () => {
        history.push('/');
    }
    const handleCopyLink = () => {
        setText(() => {
            return true;
        }, setTimeout(() => {
            setText(false);
        }, 1000))
    }
    return (
        <Fragment>
            <div className="container">
                <div className="grid">
                    <div className="grid__left grid__left--center">
                        <div className="home__illustration">
                            <Background />
                            <div
                                className="phone"
                            >
                                <img src={phone} alt="phone" />
                            </div>
                        </div>
                    </div>
                    <div className="grid__right grid__right--center">
                        <div className="home__intro home__intro--final">
                            <motion.h1
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: .6, type: "spring" }}
                            >
                                {
                                    correctAnswers < minimum ?
                                    <FormattedMessage
                                        id="final.title.bad"
                                        defaultMessage="Oh no!"
                                    />
                                    :
                                    <FormattedMessage
                                        id="final.title"
                                        defaultMessage="Nicely done!"
                                    />
                                }
                            </motion.h1>
                            <motion.p
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: .6, delay: .2, type: "spring" }}
                            >
                                {
                                    correctAnswers < minimum ?
                                    <FormattedMessage
                                        id="final.message.score.bad"
                                        defaultMessage={`You got a score of {correctAnswers}/{questionsCount} at your first attempt! It's time you paid more attention to the dangers of the internet: <a>https://www.smart-id.com/help/faq/security/</a>`}
                                        values={{
                                            correctAnswers,
                                            questionsCount,
                                            a: (...chunks) => (
                                                <a class="external_link" target="_blank" rel="noopener noreferrer" href={chunks}>
                                                  {chunks}
                                                </a>
                                              )
                                        }}
                                    />
                                    :
                                    <FormattedMessage
                                        id="final.message.score"
                                        defaultMessage={`You scored {correctAnswers}/{questionsCount} on first try. You know your way around online security.}`}
                                        values={{correctAnswers, questionsCount}}
                                    />
                                }
                            </motion.p>
                            <motion.p
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: .6, delay: .4, type: "spring" }}
                            >
                                <FormattedMessage
                                    id="final.message.share"
                                    defaultMessage="Make sure to share the quiz with your friends so they could be safe online as well."
                                />
                            </motion.p>
                            <motion.div
                                className="btn-group"
                                initial={{ y: 100, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ delay: .6, duration: .6, type: "spring" }}
                            >
                                <FormattedMessage id="final.button.over" defaultMessage="Start Over">
                                    {
                                        label =>
                                        <button type="button" onClick={startOver} className="btn btn--primary"><span className="label">{label}</span></button>
                                    }
                                </FormattedMessage>
                                <FacebookProvider appId="470852133584685">
                                    <Share href={location}>
                                        {({ handleClick, loading }) => (
                                            <FormattedMessage id="final.button.share.facebook" defaultMessage="Share on Facebook">
                                                {
                                                    label =>
                                                    <button disabled={loading} type="button" onClick={handleClick} className="btn btn--primary"><span className="label">{label}</span></button>
                                                }
                                            </FormattedMessage>
                                        )}
                                    </Share>
                                </FacebookProvider>
                                <CopyToClipboard text={location}>
                                    {
                                        !showText ?
                                        <button onClick={handleCopyLink} type="button" className="btn btn--primary">
                                            <span className="label"><FormattedMessage id="final.button.share.link" defaultMessage="Share Link" /></span>
                                        </button>
                                        :
                                        <button disabled type="button" className="btn btn--primary"><FormattedMessage id="final.button.share.link.copied" defaultMessage="Copied" /></button>
                                    }
                                </CopyToClipboard>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
            <Logo />
        </Fragment>
    )
}

export default injectIntl(Final)
